import { Link } from "react-router-dom";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "../components/ui/accordion";
import { Seo } from "../components/Seo";
import { Reveal, MaskedLines } from "../components/Motion";
import { CtaBand } from "../components/CtaBand";
import { useLang } from "../i18n/LanguageContext";
import { SITE_URL } from "../data/content";

export default function Faq() {
  const { t, data } = useLang();
  const f = t.faqPage;
  const schema = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    url: `${SITE_URL}/faq`,
    mainEntity: data.FAQS.map((q) => ({
      "@type": "Question",
      name: q.q,
      acceptedAnswer: { "@type": "Answer", text: q.a }
    }))
  };

  return (
    <>
      <Seo title={f.seoTitle} description={f.seoDesc} path="/faq" schema={schema} />
      <section className="max-w-4xl mx-auto px-6 lg:px-12 pt-16 lg:pt-24 pb-28 texture-grain" data-testid="faq-page">
        <p className="font-mono text-xs uppercase tracking-[0.3em] text-periwinkle-deep mb-6">{f.kicker}</p>
        <h1 className="font-serif text-5xl sm:text-6xl lg:text-7xl font-medium leading-[1.0] tracking-tight">
          <MaskedLines lines={f.heroLines} />
        </h1>
        <p className="mt-8 text-muted2 leading-relaxed max-w-2xl">
          {f.introPre}<Link to="/contact" className="text-periwinkle-deep link-underline font-medium">{f.introLink}</Link>{f.introPost}
        </p>

        <Reveal className="mt-16">
          <Accordion type="single" collapsible className="border-t border-ink/10">
            {data.FAQS.map((q, i) => (
              <AccordionItem key={i} value={`faq-${i}`} data-testid={`faq-item-${i}`}>
                <AccordionTrigger className="text-left font-semibold text-base hover:text-periwinkle-deep py-6">{q.q}</AccordionTrigger>
                <AccordionContent className="text-muted2 leading-relaxed pb-6">{q.a}</AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </Reveal>
      </section>
      <CtaBand />
    </>
  );
}
